import {getDocumentoID, getEdad,getGeneroID,getPrecioPlus} from "../utils/functions";
import VueCookies from 'vue-cookies';
const MiscState = require("./Misc.js")

const state = {
  ItsPromotor: false,
  CreatedByPromotor: false,
  MainMemberValidate:false,
  ZoneValidate:false,
  MembersValidate:false,
  Nombre:"",
  Apellido:"",
  Email:"",
  CodigoArea:"",
  Celular:"",
  Tipo:"",
  Documento:"",
  Genero:"",
  Nacimiento: "",
  TrackingPromo:undefined,
  Direccion:
  {
    Feeble_location:false,
    Calle:"",
    Altura:"",
    Piso:"",
    MissingFloor:false,
    Localidad:undefined,
    Busqueda:undefined,
    Latitud:undefined,
    Longitud:undefined,
    Barrio:undefined,
  },
  Price: undefined,
  Cupon:undefined,
  Members: [],
  AcceptTerms:false,
  Antecedentes: [],
  AntecedentesComentarios: {
    otrasEnfermedades:"",
    comentariosObraSocial:""
  },
  utv:1,
  PaymentMethod: "Credit"
}

const UrgPlusState = 
{
  namespaced:true,
  state,
  mutations:
  {
    setInitState(State)
    {
      State = structuredClone(state);
    },
    setTerms(state)
    {
      state.AcceptTerms = !state.AcceptTerms;
    },
    setUtv(state)
    {
      state.utv = state.utv === 1 ? 0 : 1;
    },   
    setTracingPromo(state,payload)
    {
      state.TrackingPromo = payload;
    },
    setCupon(state,Cupon)
    {
      if(Cupon)
      {
        state.Cupon = Cupon;
        if(state.utv == 0) {
          var utvUnitPrice = MiscState.default.state.Resources.prices_stamps[3].price;
          state.Cupon.totalWithGiftcard = state.Cupon.totalWithGiftcard;
        }
      }
      else
      {
        const Edad  = getEdad(state.Nacimiento);
        const Precio = getPrecioPlus(Edad);
        state.Price.discount_comment = Precio.discount_comment;
        state.Price.discount = Precio.discount;
        state.Cupon = undefined
      }
    },
    setMainPrice(state,newPrice)
    {
      state.Price.price = newPrice;
    },
    setMemberPrice(state,payload)
    {
      const {index,Precio} = payload;
      const {Comentario,Porcentaje,Total} = Precio;
      state.Members[index].Price.price = Total;
      state.Members[index].Price.discount_comment = Comentario;
      state.Members[index].Price.discount = Porcentaje;
    },
    setMainMemberValid(state)
    {
      state.MainMemberValidate = true;
    },
    setValidateZone(state)
    {
      state.ZoneValidate = true;
    },
    setValidateMembers(state)
    {
      state.MembersValidate = true;
    },
    updateMember(state,payload)
    {
      const {Index,Member} = payload;

      state.Members[Index].Nombre = Member.Nombre;
      state.Members[Index].Apellido = Member.Apellido;
      state.Members[Index].Email = Member.Email;
      state.Members[Index].Celular = Member.Celular;
      state.Members[Index].Tipo = Member.Tipo;
      state.Members[Index].Documento = Member.Documento;
      state.Members[Index].Nacimiento = Member.Nacimiento;
      state.Members[Index].Localidad = Member.Localidad;
      state.Members[Index].Direccion = Member.Direccion;
      state.Members[Index].Price = Member.Price;
      state.Members[Index].Antecedentes = Member.Antecedentes;
      state.Members[Index].AntecedentesComentarios = Member.AntecedentesComentarios;
    },
    updateValuePerson(state, {key,value}) 
    {
      state.MainMemberValidate = false;
      state.ZoneValidate = false;
      state[key] = value;}
    ,
      AddAntecedentes (state, Antecedente) {
        state.Antecedentes.push(Antecedente)
      },
      RemoveAntecedentes (state, Antecedente) {
        
        const index = state.Antecedentes.findIndex(a => a.id === Antecedente.id);

        if (index > -1) {
        state.Antecedentes.splice(index, 1);
        }
      },
      UpdateAntecedente (state, Antecedente) {
       state.AntecedentesComentarios[Antecedente.key] = Antecedente.value;
      },
        
      AddMember(state,Member)
    {
      state.Members.push(Member);
    },
    RemoveMember(state,ID)
    {
      state.Members = state.Members.filter(member => member.ID !== ID);
    },
    checkPrices(state)
    {
      const isAlone = state.Members.length === 0;
      const Edad  = getEdad(state.Nacimiento);

      const Precio = getPrecioPlus(Edad,isAlone);

      const utmSourceExists = window.location.search.includes("utm_source=") && state.TrackingPromo != null;
      const isPromotor = (VueCookies.get('codPromotor') !== null && VueCookies.get('promotorName') !== null) || state.ItsPromotor;
      
      state.Price = Precio;

      if(isPromotor)
      {
        state.Price.discount = "0.00";
        state.Price.discount_comment = "";
        state.Price.price_extra_comments = "";
        state.ItsPromotor = true;
        // if(utmSourceExists) {
        //   state.ItsPromotor = false;
        // }
      }

      for (const Member of state.Members) 
      {
        const EdadMember = getEdad(Member.Nacimiento);
        var PrecioMember = getPrecioPlus(EdadMember,false);

        if(isPromotor || utmSourceExists)
        {
          PrecioMember.discount = "0.00";
          PrecioMember.discount_comment = "";
          PrecioMember.price_extra_comments
        }

        Member.Price = PrecioMember;
      }
    },
    AddressNotFound(state, newStatus)
    {
      state.Direccion.Feeble_location = newStatus;
    },
    initState(state, payload) {
    // fusiona payload en el state reactivo
    Object.assign(state, payload);
    },
  },
  getters:
  {
    getCupon(state)
    {
      return state.Cupon;
    },
    getTrackingPromo(state)
    {
      return state.TrackingPromo;
    },
    getContinue : state => step =>
    {
      if(step === 1)
      {
        const {Nombre,Apellido,Email,CodigoArea,Celular,Tipo,Documento,Genero,Nacimiento} = state;

        if(state.Nacimiento)
        {
          var fecha = new Date();
          var fechaNacimiento = new Date(state.Nacimiento);
          var edad = fecha.getFullYear() - fechaNacimiento.getFullYear();
          var m = fecha.getMonth() - fechaNacimiento.getMonth();
          if (m < 0 || (m === 0 || fecha.getDate() < fechaNacimiento.getDate())) 
            edad--;
          
          if(edad < -1)
          {
            return false;
          }
        }

        const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        if(!patternEmail.test(state.Email))
        {
          return false;
        }

        if(Nombre === "" || Apellido === "" || Email === "" || CodigoArea === "" || Celular === "" || Tipo === "" || Documento === "" || Genero === "" || Nacimiento === "")
        {
          return false;
        }

        const LengthCelularCompleto = state.CodigoArea.length + state.Celular.length;
        if(LengthCelularCompleto !== 10)
        {
          return false;
        }
        return true;
      }
      if(step === 2)
      {
        if(state.Direccion.Localidad !== undefined && state.Direccion.Feeble_location && state.Direccion.Calle.length > 1) return true;

        if(state.Direccion.Calle === "") return false;
        
        if(state.Direccion.Altura === "") return false;
        
        return true;
      }
      if(step === 3)
      {
        return true;
      }
    },
    getShow: state => step =>
    {
      if(step === 2)
      {
        if(state.MainMemberValidate === false)
          return false;
        
        return true;
      }
      if(step === 3 || step === 4)
      {
        if(state.MainMemberValidate === false || state.ZoneValidate === false)
        {
          return false;
        }
        return true;
      }

      if(step === 5)
      {
        if(state.ItsPromotor)
          return false;

        if (!state.MainMemberValidate || !state.ZoneValidate) 
          return false;

        return true;
      }

    },
    getShowUTV(state) 
    {
      const { CreatedByPromotor, ItsPromotor , Direccion } = state;

      // if(CreatedByPromotor)
      //   return false;

      const { Localidad } = Direccion;

      if(Localidad.id == 2)
        return false;

      return true;
    },
    getSteps(state)
    {
      if(!state.MainMemberValidate)
        return [{id:"1",enable:true},{id:"2",enable:false},{id:"3",enable:false},{id:"4",enable:false}];
        
      if(!state.ZoneValidate)
        return [{id:"1",enable:true},{id:"2",enable:true},{id:"3",enable:false},{id:"4",enable:false}];

      if(!state.MembersValidate)
        return [{id:"1",enable:true},{id:"2",enable:true},{id:"3",enable:true},{id:"4",enable:false}];
          
      return [{id:"1",enable:true},{id:"2",enable:true},{id:"3",enable:true},{id:"4",enable:true}];
    },
    getEdadMainMember(state)
    {
      if(!state.Nacimiento)
      {
        return undefined;
      }

      var fecha = new Date();
      var fechaNacimiento = new Date(state.Nacimiento);
      var edad = fecha.getFullYear() - fechaNacimiento.getFullYear();
      var m = fecha.getMonth() - fechaNacimiento.getMonth();
      if (m < 0 || (m === 0 || fecha.getDate() < fechaNacimiento.getDate())) 
        edad--;
        
      if (edad === -1)
      {
        return 0;
      }
      return edad;
    },
    getPayloadMemberValidate(state)
    {
      const data = {
        'firstname': state.Nombre,
        'lastname': state.Apellido,
        'email':  state.Email,
        'document_type': '1',
        'document_number': String(state.Documento),
        'gender': '1',
        'birthday': state.Nacimiento,
        'phone': `${state.CodigoArea}-${state.Celular}`,
      }

      return data;
    },
    getPayloadMemberCookie: state => step =>
    {
      if(step == 1) {
          const data = {
            "step":1,
            "productid":1,
            "response[valid]":true,
            "response[msg]":"",
            'body': {
              'firstname': state.Nombre,
              'lastname': state.Apellido,
              'email':  state.Email,
              'document_type': getDocumentoID(state.Tipo),
              'document_number': String(state.Documento),
              'gender': getGeneroID(state.Genero),
              'birthday': state.Nacimiento,
              'phone': `${state.CodigoArea}-${state.Celular}`

            }
           
          }
    
          return data;
      }

      if(step ==2) {  
        const data = {
          "step":1,
          "productid":1,
          "body": {
            'route':state.Direccion.Calle,
            'address':state.Direccion.Calle + ' ' +state.Direccion.Altura,
            'address_number':state.Direccion.Altura,
            'city':state.Direccion.Localidad.title,
            'zone':1,
            'neighborhood':'Centro',
            'coords': {
            'lat':state.Direccion.Latitud,
            'lng':state.Direccion.Longitud},
          } ,
          "response[valid]":true,
          "response[msg]":"",
        }
  
        return data;
      }

    },
    getPayloadValidateAddress(state)
    {
      const {Direccion} = state;
      const {Latitud,Longitud,Localidad , Feeble_location} = Direccion; 

      return `coords[lat]=${Latitud}&coords[lng]=${Longitud}&zone=${Localidad.id}&feeble_location=${Feeble_location}`;
    },
    getPayloadAddress(state)
    {
      const FinalNumber = state.Direccion.MissingFloor ? "S/N" : state.Direccion.Altura;

      const data = {
        "step":2,
        "productid":1,
        "body[zone]": 1,
        "body[search_address]": state.Direccion.Calle,
        "body[search_number]": FinalNumber,
        "body[address]": state.Direccion.Calle,
        "body[address_number]": FinalNumber,
        "body[address2]": "",
        "body[neighborhood]": "",
        "body[lat]": state.Direccion.Latitud,
        "body[lng]": state.Direccion.Longitud,
        "response[code]": "",
        "response[valid]": true,
        "response[msg]": "",
      }

      return data;
    },
    getTotalPromocionFamiliar(state)
    {
      const CantidadFamiliares = state.Members.length + 1;
      
      const Promocion = MiscState.default.state.Resources.prices_group_discount.find(promocion => 
      {
        const {from,to} = promocion;
        return CantidadFamiliares >= Number(from) && CantidadFamiliares <= Number(to);
      });

      return Promocion; 
    },
    getTotal(state,getters)
    {
      var { CreatedByPromotor } = state;

      if(!state.Price)
      {
        return null;
      }

      const {price} = state.Price;

      if(!price)
      {
        return null;
      }

      var Total = 0;

      var cookies = document.cookie.split(';').map(cookie => cookie.trim());
      var cookiesObject = {};

      cookies.forEach(cookie => {
        var [name, value] = cookie.split('=');
        cookiesObject[name] = decodeURIComponent(value);
      });

      Total += Number(price);
      var utmSourceExists = false;

      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      // Verificar si existe "utm_source" y obtener su valor
      if (params.has('utm_source')) {
          const utmSource = params.get('utm_source');
          if(utmSource == 'cotizacionwhatsapp') {
            CreatedByPromotor = true;
          }
        } 

      if(window.location.search.includes("utm_source=") && getters.getTrackingPromo != null) {
        utmSourceExists = window.location.search.includes("utm_source=");
      }

      
      const ItsPromotor = state.ItsPromotor || (VueCookies.get('codPromotor') !== null);
      if(!CreatedByPromotor && !utmSourceExists && !ItsPromotor){ // Si es un usuario común

        let discount_payment_method = 0; 
        state.PaymentMethod === "Debit" ? discount_payment_method = Number(state.Price.discount_cbu) : discount_payment_method = Number(state.Price.discount_cc);

        if(discount_payment_method !== 0) { // Si hay promo, piso el precio con la promo
          var discountAmount = Total * (discount_payment_method / 100);
          Total -= discountAmount;
        }
      } else { // Si es un promotor
        state.Price.discount = "0.00";
        state.Price.discount_comment = null;
      }

      Total = Math.ceil(Total);

      state.Members.forEach(member =>
      {
        if(!CreatedByPromotor && !utmSourceExists && !ItsPromotor){ 
          let discount_pm = 'cc';
          state.PaymentMethod === "Debit" ? discount_pm = 'cbu' : discount_pm = 'cc';
          if(member.Price[`discount_${discount_pm}`] === "0.00") {
            Total += Math.ceil(Number(member.Price.price));
          }
          else {
            Total += (Math.ceil(Number(member.Price.price)) - (Math.ceil(Number(member.Price.price)) * (Number(member.Price[`discount_${discount_pm}`]) / 100)));
          }
        } else {
           Total += Math.ceil(Number(member.Price.price));
        }

      });

      const PromoTracking = getters.getTrackingPromo;

      if(PromoTracking)
      {
        const {discount, branch} = PromoTracking;
       
        const LocalidadId = state.Direccion.Localidad.id;

        if(branch === "0" || branch === LocalidadId)
          if(Number(discount) > 0)
            Total = Math.ceil(Total - (Total * (Number(discount) / 100)));
      }
      else
      {

        const PromocionFamiliar = getters.getTotalPromocionFamiliar;

        const {discount} = PromocionFamiliar;

        if(Number(discount) > 0)
          Total = Math.ceil(Total - (Total * (Number(discount) / 100)));
      }
      
      let utvUnitPrice = 0;
      if(getters.getShowUTV)
      {
        utvUnitPrice = MiscState.default.state.Resources.prices_stamps[3].price;

      if(state.utv == 1)
          Total = (utvUnitPrice * (state.Members.length + 1)) + Total;

      }

      
      if (state.Cupon) {
        
          let total = Number(state.Cupon.totalWithGiftcard);
      
          state.utv === 1 ? total += (utvUnitPrice * (state.Members.length + 1)) : null;

          return Math.ceil(total);
        }

      return Math.ceil(Total);
    },
    getLengthPersonas(state)
    {
      return state.Members.length + 1;
    },
    getExtraComment(state)
    {
      return state.Price.extra_comments;
    },
    getMembersDocuments(state)
    {
      var Documents = [];
      Documents.push(state.Documento);

      for (const Member of state.Members) 
      {
        Documents.push(Member.Documento)
      }

      return Documents;
    },
    getMainMember(state)
    {
      return state;
    },
    getEdadMainMember(state)
    {
      return getEdad(state.Nacimiento);
    },
    getMembers(state)
    {
      return state.Members;
    },
    getDisableSecondStep(){
      var disabled = false
      return;
    },
    getDisableThirdStep() {
      var disabled = false;
      switch(true) {
        case getEdad(state.Nacimiento) < 75:
          break;
        case getEdad(state.Nacimiento) >= 75 && getEdad(state.Nacimiento) <= 80:
          disabled = true;
          break;
      }

      if(state.Members.length > 0) {
        state.Members.map(el=> {
          var edad = getEdad(el.Nacimiento);
          switch(true) {
            case edad < 75:
              disabled = false;
              break;
            case edad >= 75 && edad <= 80 && state.Nacimiento >= 75:
            disabled = true;
              break;
          }
    
        })
      }

      return disabled;
    },
    getItsPromotor(state)
    {
      return state.ItsPromotor;
    }
  }
}

export default UrgPlusState